import React from 'react';
import { ISection } from 'src/interface';
import { renderSections } from '.';

export default React.memo(function MoreSection(section: ISection<any>) {
    if (!section || !section.items || !section.items.length) {
        return null;
    }

    return <>{renderSections(section.items as [])}</>;
});
